/**
 * @desc 新增
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.SalesChannelResponseDto>;
export function request(
  body: defs.basics.SalesChannelRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/salesChannel/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
